import { GET_PHYSICAL_LIST_DATA, SET_PHYSICAL_LOADING, CLEAR_PHYSICAL } from './physicalExam.type'
import axios from 'axios'
import { toggleDeactivateModal, toggleSessionModal } from '../modals/toggleModal.actions'

export const getPhysicalListData = (payload, token) => async (dispatch) => {
    dispatch({
        type: SET_PHYSICAL_LOADING,
        payload: true,
    })
    axios
        .get(`${process.env.REACT_APP_CARD_URL}/physical-exam?patientId=${payload?.patientId}`, {
            headers: {
                accessToken: token,
            },
        })
        .then((response) => {
            if (response.data.status === 200) {
                dispatch({
                    type: GET_PHYSICAL_LIST_DATA,
                    payload: response.data.output,
                })
                dispatch({
                    type: SET_PHYSICAL_LOADING,
                    payload: false,
                })
            } else if (response.data.status === 400) {
                dispatch(toggleSessionModal(true, response?.data?.error))
                dispatch({
                    type: SET_PHYSICAL_LOADING,
                    payload: false,
                })
            } else if (response.data.status === 401) {
                dispatch(toggleSessionModal(true, response?.data?.error))
                dispatch({
                    type: SET_PHYSICAL_LOADING,
                    payload: false,
                })
            } else if (response.data.status === 403) {
                dispatch(toggleDeactivateModal(true))
                dispatch({
                    type: SET_PHYSICAL_LOADING,
                    payload: false,
                })
            }
        })
        .catch((err) => {
            // console.log(err)
        })
}

export const clearPhysical = () => (dispatch) => {
    dispatch({
        type: CLEAR_PHYSICAL,
    })
}
